import { cn } from '@/lib/cn'

export type ScanState = 'preparing' | 'good' | 'trouble'

/**
 * The card's own colour, washed in from its edges: green while the vendor is happy with what it
 * sees, red while it is not.
 *
 * Two fixed layers cross-faded on opacity rather than one layer whose colour changes: a
 * `background` holding a gradient does not interpolate between two values, so a single layer would
 * snap from green to red on the frame the vendor first complains.
 */
export function ScanStatusWash({ state }: { readonly state: ScanState }) {
  return (
    <>
      <Layer visible={state === 'good'} centre="rgba(34,197,94,0.28)" edge="rgba(34,197,94,0.8)" />
      <Layer visible={state === 'trouble'} centre="rgba(239,68,68,0.28)" edge="rgba(239,68,68,0.8)" />
    </>
  )
}

function Layer({
  visible,
  centre,
  edge,
}: {
  readonly visible: boolean
  readonly centre: string
  readonly edge: string
}) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'pointer-events-none absolute inset-0 transition-opacity duration-700 ease-out',
        visible ? 'opacity-100' : 'opacity-0',
      )}
      style={{ background: `radial-gradient(125% 95% at 50% 45%, ${centre} 0%, ${edge} 100%)` }}
    />
  )
}
